import React from 'react';
import QuestionDependency from '../QuestionDependency';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const PDFActivityManuscript = ({ model, isManuscriptShort }) => {
  return (
    <div className='element-container'>
      <div className='label-value-row'>
        <div>Activity Type:</div>
        <div>PDF Activity</div>
      </div>
      <div className='label-value-row'>
        <div>Questions:</div>
        <div>{model.questionRange}</div>
      </div>
      <div className='label-value-row'>
        <div>Directions:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.directions} /></div>
      </div>
      <div className='label-value-row'>
        <div>Title:</div>
        <div>{model.title}</div>
      </div>
      <div className='label-value-row'>
        <div>Viewer:</div>
        <div>{model.pdfViewerTool || '—'}</div>
      </div>
      <div className='label-value-row'>
        <div>Pages:</div>
        <div>{model.startPage != null && model.endPage != null ? `${model.startPage}–${model.endPage}` : '—'}</div>
      </div>
      <div className='label-value-row'>
        <div>Source URL:</div>
        <div>{model.sourceUrl}</div>
      </div>
      {model.sourceUrl && (
        <iframe src={model.sourceUrl} title={model.title || 'PDF'} />
      )}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Show All Items At Once:</div>
            <div>{(model.showAllChildren) ? 'ON' : 'OFF'}</div>
          </div>
          <div className='label-value-row'>
            <div>childPages (content id → page):</div>
            <div><pre style={{ whiteSpace: 'pre-wrap' }}>{model.childPages ? JSON.stringify(model.childPages, null, 2) : '—'}</pre></div>
          </div>
        </>
      )}
    </div>
  );
};

export default PDFActivityManuscript;
